var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ItemPage',{attrs:{"narrowCols":[]},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('span',[_vm._v("Not Found.")]),_c('small',[_vm._v("The requested URL was not found on this server.")])]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }